import React from 'react';

/**
 * 車隊狀態標誌組件
 * @param {Object} props
 * @param {string} props.status - 車隊狀態
 * @param {string} props.className - 額外的CSS類名
 */
const FleetStatusBadge = ({ status, className = '' }) => {
    const getStatusConfig = () => {
        switch (status) {
            case 'active':
                return {
                    label: '運營中',
                    bgColor: 'bg-green-100',
                    textColor: 'text-green-600',
                    dotColor: 'bg-green-500'
                };
            case 'inactive':
                return {
                    label: '暫停運營',
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
            case 'suspended':
                return {
                    label: '已停用',
                    bgColor: 'bg-red-100',
                    textColor: 'text-red-600',
                    dotColor: 'bg-red-500'
                };
            case 'maintenance':
                return {
                    label: '系統維護',
                    bgColor: 'bg-yellow-100',
                    textColor: 'text-yellow-600',
                    dotColor: 'bg-yellow-500'
                };
            default:
                return {
                    label: status,
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600',
                    dotColor: 'bg-gray-500'
                };
        }
    };

    const { label, bgColor, textColor, dotColor } = getStatusConfig();

    return (
        <div className={`flex items-center ${className}`}>
            <div className={`w-2 h-2 rounded-full ${dotColor} mr-2`}></div>
            <span className={`px-2 py-1 rounded-full text-xs ${bgColor} ${textColor}`}>
                {label}
            </span>
        </div>
    );
};

export default FleetStatusBadge;